import { openPrintWindow } from '@/lib/printWindow';
import { LABEL_FONT_IMPORT, LABEL_STYLE } from './labelSizes';

const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => (
  { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

/**
 * プレビューDOM内の .ql-label をそのまま QL-800 のロールへ印刷する。
 * Brother QL のロールはテープ幅が固定なので、@page はロール実寸（幅×長さ）に
 * 一致させないとドライバがロール不一致で拒否する。ラベルは可読性のため横長に
 * 設計しているので、縦長メディアに載せるときは内容を90°回転させる。
 * 印刷ダイアログとテストシートで同じ経路を使う（レンダラを二重化しない）。
 */
export function printLabelNodes(container, sz, title) {
  if (!container) return null;
  const isCont = !sz.h;
  const rotate = !isCont && sz.w !== sz.h;
  const pageW = isCont ? sz.w : Math.min(sz.w, sz.h);
  const pageLen = isCont ? null : Math.max(sz.w, sz.h);
  const pageSize = `${pageW}mm ${pageLen ? `${pageLen}mm` : 'auto'}`;

  let body = '';
  container.querySelectorAll('.ql-label').forEach((node) => {
    body += rotate
      ? `<div class="ql-page"><div class="ql-rot">${node.outerHTML}</div></div>`
      : `<div class="ql-page">${node.outerHTML}</div>`;
  });

  const printCss = `
    ${LABEL_FONT_IMPORT}
    @page{ size:${pageSize}; margin:0 } html,body{ margin:0; padding:0 }
    .ql-page{ width:${pageW}mm; height:${pageLen ? `${pageLen}mm` : 'auto'};
      position:relative; overflow:hidden; page-break-after:always; background:#fff; }
    .ql-page:last-child{ page-break-after:auto; }
    ${rotate ? `.ql-rot{ position:absolute; top:0; left:0; width:${pageLen}mm; height:${pageW}mm;
      transform:translateX(${pageW}mm) rotate(90deg); transform-origin:top left; }` : ''}
    ${LABEL_STYLE}`;

  return openPrintWindow(
    `<html><head><meta charset="utf-8"><title>${esc(title || 'label')}</title>
    <style>${printCss}</style></head><body>${body}</body></html>`,
    { features: 'width=540,height=680', delay: 500 },
  );
}
